import { css } from "@emotion/css";
import commonStyles from "utility/ui/common";

const styles = {
  btn: (isDesktop) =>
    isDesktop
      ? css`
          max-width: 150px !important;
        `
      : commonStyles.controlBtnMobile,
};

export default styles;
